export default "__VITE_ASSET__BXsAtF1d__"